import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { StepperComponent } from './components/stepper/stepper.component';
import { BackNavigationComponent } from './components/back-navigation/back-navigation.component';
import { Step } from './components/stepper/stepper';
import { STEPS } from './roaming.data';
import { filter } from 'rxjs';
import { ITEM } from '@utils/constants';
@Component({
  selector: 'app-roaming',
  standalone: true,
  imports: [RouterOutlet, StepperComponent, BackNavigationComponent],
  templateUrl: './roaming.component.html',
  styleUrl: './roaming.component.scss'
})
export class RoamingComponent implements OnInit {
  steps = signal<Step[]>(STEPS);

  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);

  ngOnInit(): void {
    const FIRST_STEP = 1;
    const SECOND_STEP = 2;
    // Get initial child route params
    const childRoute = this.route.firstChild;
    if (childRoute) {
      
      const currentPath = childRoute.snapshot.url[ITEM.EMPTY_LENGTH]?.path;
      if (currentPath === 'set-schedule') {
        this.updateStep(FIRST_STEP);
      } else if (currentPath === 'checkout') {
        this.updateStep(SECOND_STEP);
      }
    }

    // Subscribe to future navigation events
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (event.url.includes('set-schedule')) {
        this.updateStep(FIRST_STEP);
      } else if (event.url.includes('checkout')) {
        this.updateStep(SECOND_STEP);
      }
    });
  }

  updateStep(currentStep: number) {
    this.steps.update(steps => {
      return steps.map(step => ({
        ...step,
        state: step.id <= currentStep ? 'active' : '',
        isCurrenPosition: step.id === currentStep
      }));
    });
  }
}